import { useEffect, useState } from "react"

import { useQueryParam } from "web/hooks/context"
import { isNonEmptyArray, distinctBy, unique } from "web/services/helpers"

import { getMapBoxSafeValues } from "./common"

import LocationMap from "./LocationMap"
import SaleLocationCard from "./LocationCard/SaleLocationCard"

export default function SaleMap({
  sales,
  onSelectionChanged,
  onItemClick,
  isLoading,
  showOrdinals,
}) {
  const [locationInFocus, setLocationInFocus] = useState()
  const hasLocationInFocus = !!locationInFocus

  const saleLocations = sales.reduce((locations, sale) => {
    const saleValues = getMapBoxSafeValues(sale.values)

    if (isNonEmptyArray(sale.locations)) {
      locations.push(
        ...sale.locations.map((al) => ({
          ...al,
          sticky: sale.sticky,
          comparable_deal_id: sale.id,
          values: saleValues,
        }))
      )
    }

    return locations
  }, [])

  const distinctSaleLocations = distinctBy(saleLocations, "id")

  const locationInFocusWithSubjects = { location: locationInFocus }

  if (hasLocationInFocus) {
    const salesAtLocation = sales.filter((sale) =>
      sale.locations?.some((location) => location.id === locationInFocus.id)
    )

    const assetIdsAtLocation = salesAtLocation
      .map((sale) => sale.locations)
      .flat()
      .filter((location) => location.id === locationInFocus.id)
      .map((location) => location.asset_id)

    const distinctAssetIdsAtLocation = unique(assetIdsAtLocation)

    locationInFocusWithSubjects.sales = salesAtLocation
    locationInFocusWithSubjects.assetIds = distinctAssetIdsAtLocation
  }

  const primarySubject =
    hasLocationInFocus && locationInFocusWithSubjects.sales[0]

  const hasPrimarySubject = !!primarySubject

  // deal in focus may have been removed between
  // renders by change in filter conditions
  useEffect(() => {
    if (hasLocationInFocus && !hasPrimarySubject) {
      setLocationInFocus(undefined)
    }
  }, [hasLocationInFocus, hasPrimarySubject])

  const selected = sales.filter((el) => el.selected)

  const center_on = useQueryParam("center_on")
  const centralLocation =
    // eslint-disable-next-line eqeqeq
    !!center_on &&
    distinctSaleLocations.find(
      (location) => location.comparable_deal_id == center_on
    )

  return (
    <LocationMap
      subjectType="sale"
      subjects={sales}
      primarySubject={primarySubject}
      selected={selected}
      locations={distinctSaleLocations}
      locationInFocus={locationInFocusWithSubjects}
      centralLocation={centralLocation}
      onLocationClick={setLocationInFocus}
      onSelectionChanged={onSelectionChanged}
      onItemClick={onItemClick}
      detailCard={SaleLocationCard}
      isLoading={isLoading}
      canRecenterMap={true}
      showOrdinals={showOrdinals}
    />
  )
}
